import { render, staticRenderFns } from "./demandType.vue?vue&type=template&id=4d861f56&"
import script from "./demandType.vue?vue&type=script&lang=js&"
export * from "./demandType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports